import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { processFile } from "@/api/process";

const twoMonthsAgo = () => {
  const now = new Date();
  const target = new Date(now.getFullYear(), now.getMonth() - 2, 1);
  const end = new Date(target.getFullYear(), target.getMonth() + 1, 0);
  const month = target.toLocaleString("en-US", { month: "long" });
  return `${month} 1 - ${month} ${end.getDate()}`;
};

const Index = () => {
  const [file, setFile] = useState<File | null>(null);
  const [status, setStatus] = useState<
    "idle" | "uploading" | "success" | "error"
  >("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [employees, setEmployees] = useState<string[]>([]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) return;

    setStatus("uploading");
    setErrorMessage("");

    try {
      const result = await processFile(file);
      setEmployees(result.employees);
      setStatus("success");
      setFile(null);
    } catch (err: unknown) {
      setStatus("error");
      setErrorMessage(
        err instanceof Error ? err.message : "Failed to process file",
      );
    }
  };

  return (
    <div className="p-4">
      <h3>Process Negative Points</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="file" className="form-label">
            Upload XLS Schedule File
          </label>
          <input
            id="file"
            type="file"
            className="form-control"
            accept=".xls,.xlsx"
            onChange={(e) => {
              setFile(e.target.files?.[0] ?? null);
              setStatus("idle");
            }}
          />
          <div className="form-text">
            This file must come from ESO. To get it, go to{" "}
            <strong>
              ESO Scheduler &gt; Employees &gt; Employee Reports &gt; Employee
              Hours Worked By Date Span
            </strong>
            .<br /> Select the following date range:{" "}
            <strong>{twoMonthsAgo()}</strong>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={!file || status === "uploading"}
        >
          {status === "uploading" ? "Processing..." : "Upload & Process"}
        </button>
      </form>
      {status === "success" && (
        <div className="alert alert-success mt-3">
          <strong>File processed successfully.</strong>
          {employees.length > 0 && (
            <>
              <p className="mb-1 mt-2">Employees processed ({employees.length}):</p>
              <ul className="mb-0">
                {employees.map((name) => (
                  <li key={name}>{name}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
      {status === "error" && (
        <div className="alert alert-danger mt-3">{errorMessage}</div>
      )}
    </div>
  );
};

export const Route = createFileRoute("/")({
  component: Index,
});
